import React from 'react';
import { useParams } from 'react-router-dom';
import { Renderer } from '../components/content/ContentRenderer';
import { usePostHub } from '../controllers/PostHubController';
import { usePostPage } from '../hooks/usePostPage';

export const PostPage = (): JSX.Element => {
  const { '*': slug } = useParams();

  return <PostPageLoader key={slug} slug={slug} />;
};

const PostPageLoader = ({ slug }: { slug?: string }) => {
  const { engineId, basePath } = usePostHub();
  const { isLoading, data, error } = usePostPage(engineId, basePath.replace(/^\/+/, ''), slug ?? '');

  return <Renderer isLoading={isLoading} page={data?.page} error={error} />;
};
